module.exports = new __parcel__URL__("jennings_lo.b0822633.glb").toString();